// extracted by mini-css-extract-plugin
export default {"poetrySpot":"PoetrySpot_poetrySpot__cetiH","poetrySpotContent":"PoetrySpot_poetrySpotContent__iF+qs","name":"PoetrySpot_name__pZ3nt","summary":"PoetrySpot_summary__2DTWt"};